// removed by extract-text-webpack-plugin
module.exports = {"root":"root--48daa","avatar":"avatar--2af52"};